import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

export default function Toast({ message, type, onClose }: ToastProps) {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <>
      <div style={{
        position: 'fixed', bottom: 32, right: 32, zIndex: 9999,
        background: type === 'success' ? 'rgba(20,20,40,0.97)' : 'rgba(40,10,10,0.97)',
        border: `1px solid ${type === 'success' ? '#E8871A' : '#c0392b'}`,
        borderRadius: 12, padding: '16px 24px',
        display: 'flex', alignItems: 'center', gap: 12,
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        animation: 'toastIn 0.3s ease',
        maxWidth: 360,
      }}>
        <span style={{ fontSize: 22 }}>{type === 'success' ? '🙏' : '❌'}</span>
        <p style={{ color: '#FDF6EC', fontSize: 14, lineHeight: 1.5, margin: 0 }}>{message}</p>
        <button onClick={onClose} style={{
          background: 'none', border: 'none', color: 'rgba(253,246,236,0.5)',
          cursor: 'pointer', fontSize: 18, marginLeft: 8, padding: 0, lineHeight: 1
        }}>×</button>
      </div>
      <style>{`@keyframes toastIn { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </>
  );
}
